var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircleloaderfive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 24,
    viewBox: "0 0 22.5 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "circleloaderfive",
    d: "M10.5,24a11.77,11.77,0,0,1-4.629-.926,12.022,12.022,0,0,1-3.856-2.589L3.07,19.43A10.464,10.464,0,0,1,.808,16.055,10.493,10.493,0,0,1,.832,7.922a10.313,10.313,0,0,1,5.589-5.59A10.278,10.278,0,0,1,10.5,1.5V0a11.772,11.772,0,0,1,4.664.949,11.742,11.742,0,0,1,6.387,6.387,11.932,11.932,0,0,1,0,9.328,11.742,11.742,0,0,1-6.387,6.387A11.772,11.772,0,0,1,10.5,24Zm-9-12a8.842,8.842,0,0,0,.691,3.469,9.227,9.227,0,0,0,1.934,2.907L5.2,17.3a7.23,7.23,0,0,0,2.4,1.629A7.42,7.42,0,0,0,10.5,19.5a7.317,7.317,0,0,0,3.762-1.008,7.5,7.5,0,0,0,2.73-2.73,7.524,7.524,0,0,0,0-7.524,7.514,7.514,0,0,0-2.73-2.73A7.312,7.312,0,0,0,10.5,4.5V3A8.814,8.814,0,0,0,5.988,4.207,8.931,8.931,0,0,0,2.707,7.489,8.814,8.814,0,0,0,1.5,12Z",
    fill: "#74788d"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleloaderfive);
export default __webpack_public_path__ + "static/media/circleloaderfive.772587f8.svg";
export { ForwardRef as ReactComponent };